import { Route } from '@angular/router';

import { UserRouteAccessService } from '../shared';
import { UsersFinantialStatusReportComponent } from './';

export const USERS_FINANTIAL_STATUS_REPORT_ROUTE: Route = {
    path: 'users-finantial-status-report',
    data: {
        authorities: ['ROLE_SCHOOL_ADMIN'],
        pageTitle: 'jYoguiApp.users-finantial-status-report.title'
    },
    component: UsersFinantialStatusReportComponent,
    canActivate: [ UserRouteAccessService ]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/users-finantial-status-report/users-finantial-status-report-component.route.ts